import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useTranslation } from "react-i18next";
import { DailyMetric } from "../../api/types";

/**
 * Net follow delta per day: positive bars = follows, negative bars = unfollows. The two
 * stack symmetrically around zero so the user can read the day's net at a glance.
 */
export default function FollowDeltaChart({ data }: { data: DailyMetric[] }) {
  const { t } = useTranslation();
  const series = data.map((d) => ({
    date: d.date,
    follows: d.interactionsByType.follow || 0,
    unfollows: -(d.interactionsByType.unfollow || 0),
  }));

  return (
    <ResponsiveContainer width="100%" height={220}>
      <BarChart data={series} stackOffset="sign">
        <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
        <XAxis dataKey="date" tick={{ fill: "#94a3b8", fontSize: 12 }} />
        <YAxis tick={{ fill: "#94a3b8", fontSize: 12 }} />
        <ReferenceLine y={0} stroke="#475569" />
        <Tooltip
          contentStyle={{
            background: "#0f172a",
            border: "1px solid #334155",
            borderRadius: 8,
            color: "#e2e8f0",
          }}
          formatter={(value: number, name: string) => [Math.abs(value), name]}
        />
        <Legend wrapperStyle={{ color: "#cbd5e1", fontSize: 12 }} />
        <Bar
          dataKey="follows"
          stackId="x"
          fill="#f472b6"
          name={t("interaction.typePlural.follow")}
        >
          {series.map((_, i) => (
            <Cell key={i} fill="#f472b6" />
          ))}
        </Bar>
        <Bar
          dataKey="unfollows"
          stackId="x"
          fill="#94a3b8"
          name={t("interaction.typePlural.unfollow")}
        >
          {series.map((_, i) => (
            <Cell key={i} fill="#94a3b8" />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
